import { render } from "./Slide.vue?vue&type=template&id=674bc45e&scoped=true"
import script from "./Slide.vue?vue&type=script&lang=js"
export * from "./Slide.vue?vue&type=script&lang=js"

import "./Slide.vue?vue&type=style&index=0&id=674bc45e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-674bc45e"

export default script